import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {SharedService} from '../../../../services/shared-service/shared.service';
import {AnonymousService} from '../../../../services/anonymous-service';
import {AuthService} from '../../../../services/auth-service/auth-service.service';
import {UserService} from '../../../../services/users-service/user-service';
import {Router} from '@angular/router';
import {MdSnackBar, MdSnackBarConfig} from '@angular/material';
import {FormBuilder, FormGroup, FormGroupDirective, Validators} from '@angular/forms';
import {ErrorService} from '../../../../util/error_service/error.service';
import {ToastService} from '../../../../util/toast-service/toast.service';
import {Constants} from '../../../../util/Constants';
import '../../../../util/custom-alert/custom-alert.component';

@Component({
  selector: 'app-quick-funding',
  templateUrl: './quick-funding.component.html',
  styleUrls: ['./quick-funding.component.scss']
})
export class QuickFundingComponent implements OnInit {
  public switchCreate: boolean;
  public isloading: boolean;
  public uplodText: String;
  public agentType: String;
  public userDetails : any ;
  public userExists : any ;
  public agentsWithLowWallet : any;
  public isLoadingFromList : boolean;
  public fundStatus : boolean;

  public agentId: any;
  public amount : number;
  mobnumPattern = '^((\\+91-?)|0)?[0-9]{7,14}$';
  public errorText: String;
  public searchData: any;
  public fundMessage : string
  public userData : any = {
    'id' : null,
    'fullName' : null,
    'email' : null,
    'phone' : null,
    'walletBalance' : null
  }
  public fundingSuccessful: boolean;
  public isLoadingAgents: boolean;
  pageTitle: string = 'Fund Agent';


  constructor(public sharedService: SharedService, public anonymousService: AnonymousService,
              public authService: AuthService, public agentService: UserService,
              public router: Router, public snackBar: MdSnackBar, public fb: FormBuilder, public errorHandler: ErrorService,
              public toast: ToastService) {
    this.sharedService.emitChange(this.pageTitle);
    this.switchCreate = true;
    this.uplodText = 'Upload Agents';
    this.isloading = false;
    this.searchData = '';
    this.userDetails = null;
    this.errorText = '';
    this.userExists = false;
    this.fundingSuccessful = false;
    this.agentsWithLowWallet = '';
    this.isLoadingAgents = false;
    this.fundStatus = false;

    this.agentId = '';
    this.amount = null;

    this.userData.id =  '-';
    this.userData.fullName =  '-';
    this.userData.email = '-';
    this.userData.phone = '-';
    this.userData.walletBalance = '-';
  }

  ngOnInit() {
    this.getAllAgents();
  }

  cancelAction = () => {
    // console.log('cancel')
    if(this.userExists){
      this.searchData = '';
      this.userExists = false
    }else{
      this.userExists = true;
    }
  }

  // search user
  searchUser = (searchEmail ?: string, isFromList: boolean = false) => {
    this.isloading = true;
    this.errorText = '';
    this.fundingSuccessful = false;
    this.amount = null;
    this.isLoadingFromList = isFromList;

    this.sharedService.checkUserExist(searchEmail ? searchEmail : this.searchData , this.searchData).subscribe(
      response => {

          this.userDetails = response.data;
          this.userExists = true;

          this.userData.id = this.userDetails[0].id;
          this.userData.fullName =  this.userDetails[0].firstName + ' ' + this.userDetails[0].lastName;
          this.userData.email = this.userDetails[0].email;
          this.userData.phone = this.userDetails[0].mobile;
          this.userData.walletBalance = this.userDetails[0].walletBalance;
          this.isloading = false;
          this.isLoadingFromList = false;
          // console.log(this.userData);
      }, err => {
        const error = this.errorHandler.errorHandlerWithText(this.searchUser, err);
        this.errorText = error.message;
        this.isloading = false;
        this.isLoadingFromList = false;
        this.userData.id =  '-';
        this.userData.fullName =  '-';
        this.userData.email = '-';
        this.userData.phone = '-';
        this.userData.walletBalance = '-';
      })
  }


  fundAgent = (agentId : any, agentFullname: string) => {
    this.fundStatus = true;

    this.agentService.fundWallet(agentId, this.amount).subscribe(
      data => {
        this.getAllAgents();
        this.fundStatus = false;
        this.fundingSuccessful = true;
        this.fundMessage = agentFullname+' wallet was credited with ₦'+this.amount+' successfully';
      },
      err => {
        const error = this.errorHandler.errorHandlerWithText(this.fundAgent, err);
        // console.log(error.message);
        this.toast.showError(error.message, 'Error');
      }
    )
  }

  fundAnotherAgent = () => {
    this.fundingSuccessful = false;
    this.cancelAction();
  }

  // get list of all agents
  getAllAgents = () => {
    this.isLoadingAgents = true;
    this.agentService.getAgents(20).subscribe(
      response => {
        // console.log("************ 10 Agents list ****************");
        let agentlist = response.data[0].content;
        // console.log("********* agents ******");
        // console.log(response.data[0].content);
        this.agentsWithLowWallet = agentlist.filter(agent => agent.walletBalance < 2000);
        // console.log("********* agents less than 5k  ******");
        // console.log(this.agentsWithLowWallet);
        this.isLoadingAgents = false;
      },
      err => {
        const error = this.errorHandler.errorHandlerWithText(this.getAllAgents, err);
        this.toast.showError(error.message, 'Error');

      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/funding/quick-funding/quick-funding.component.ts